__turbopack_context__.v({
  "badge": "MultiCombobox-module__A9e6aa__badge",
  "badgeLabel": "MultiCombobox-module__A9e6aa__badgeLabel",
  "badgeWrap": "MultiCombobox-module__A9e6aa__badgeWrap",
  "chevronButton": "MultiCombobox-module__A9e6aa__chevronButton",
  "control": "MultiCombobox-module__A9e6aa__control",
  "inner": "MultiCombobox-module__A9e6aa__inner",
  "input": "MultiCombobox-module__A9e6aa__input",
});
